module.exports = __webpack_public_path__ + "img/UTKODA-13.56f067d1.jpg";